module.exports = __webpack_public_path__ + "static/media/icon-marcas.0ae0d137.svg";